import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import * as Styled from './styled';

function StopAmenitiesList({ amenities }) {
  return (
    <Styled.StopAmenitiesListBody>
      <Styled.StopAmenitiesHeader>
        <FormattedMessage id="detailview.stopamenitiesheader" />
      </Styled.StopAmenitiesHeader>
      {amenities && amenities.length ? (
        <Styled.StopAmenitiesItemContainer>
          {amenities.map(am => (
            <Styled.StopAmenitiesItem key={am.desc}>
              <Styled.CheckIcon />
              {am.desc}
            </Styled.StopAmenitiesItem>
          ))}
        </Styled.StopAmenitiesItemContainer>
      ) : null}
    </Styled.StopAmenitiesListBody>
  );
}

StopAmenitiesList.propTypes = {
  /** A collection of Stop Amenities to be displayed */
  amenities: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default StopAmenitiesList;
